import { put, takeLatest, all, call } from 'redux-saga/effects'
import {
  getContractDetailSuccessAction,
  getMeterDetailSuccessAction,
  getMonthContractSuccessAction,
  getMonthBillDetailSuccessAction,
  getPdfBillSuccessAction,
  getMonthContractIdSuccessAction,
  getMonthContractIdNewSuccessAction,
} from 'src/redux/actions/monthContract'
import {
  ACTION_GET_METER_DETAIL,
  ACTION_GET_MONTH_CONTRACT,
  ACTION_GET_MONTH_CONTRACT_DETAIL,
  ACTION_GET_MONTH_BILL_DETAIL,
  ACTION_GET_PDF_BILL,
  ACTION_GET_MONTH_CONTRACT_ID_OLD,
  ACTION_GET_MONTH_CONTRACT_ID_NEW,
} from 'src/redux/actions/monthContract/monthContractActions'
import instance from 'src/services/api'
import { Endpoint } from '../Endpoint'
import { generatePath } from 'react-router-dom'
import queryString from 'query-string'

function* getMonthContract(action) {
  try {
    const configRequest = () => {
      return instance.get(`${Endpoint.INVOICE_GET_BILL_AMOUNT}?${action.payload}`)
    }
    const response = yield call(configRequest)
    const newResult = {
      ...response?.data,
      param: queryString?.parse(action?.payload),
    }
    yield put(getMonthContractSuccessAction(newResult))
  } catch (error) {
    const status = error?.response?.data?.status
    const msg = error?.response?.data?.error?.message
    const code = error?.response?.data?.error?.code
    yield put(
      getMonthContractSuccessAction({
        status: status,
        code: code,
        message: msg,
        param: queryString?.parse(action?.payload),
      }),
    )
  }
}

function* getMonthYearContract(action) {
  try {
    const configRequest = () => {
      return instance.get(`${Endpoint.INVOICE_GET_BILL_AMOUNT}?${action.payload}`)
    }
    const response = yield call(configRequest)
    const newResult = {
      ...response?.data,
      param: queryString?.parse(action?.payload),
    }
    yield put(getMonthContractIdSuccessAction(newResult))
  } catch (error) {
    const status = error?.response?.data?.status
    const msg = error?.response?.data?.error?.message
    const code = error?.response?.data?.error?.code
    yield put(
      getMonthContractIdSuccessAction({
        status: status,
        code: code,
        message: msg,
        param: queryString?.parse(action?.payload),
      }),
    )
  }
}

function* getMonthYearNewContract(action) {
  try {
    const configRequest = () => {
      return instance.get(`${Endpoint.INVOICE_GET_BILL_AMOUNT}?${action.payload}`)
    }
    const response = yield call(configRequest)
    const newResult = {
      ...response?.data,
      param: queryString?.parse(action?.payload),
    }
    yield put(getMonthContractIdNewSuccessAction(newResult))
  } catch (error) {
    const status = error?.response?.data?.status
    const msg = error?.response?.data?.error?.message
    const code = error?.response?.data?.error?.code
    yield put(
      getMonthContractIdNewSuccessAction({
        status: status,
        code: code,
        message: msg,
        param: queryString?.parse(action?.payload),
      }),
    )
  }
}

function* getContractDetail(action) {
  try {
    const configRequest = () => {
      return instance.get(`${Endpoint.FEE_DETAIL}?${action.payload}`)
    }
    const response = yield call(configRequest)
    yield put(getContractDetailSuccessAction(response?.data))
  } catch (error) {
    const status = error?.response?.data?.status
    const msg = error?.response?.data?.error?.message
    const code = error?.response?.data?.error?.code
    yield put(
      getContractDetailSuccessAction({
        status: status,
        code: code,
        message: msg,
      }),
    )
  }
}

function* getMeterDetail(action) {
  try {
    const url = generatePath(Endpoint.METER_DETAIL, {
      contract_id: action?.payload,
    })
    const configRequest = () => {
      return instance.get(url)
    }
    const response = yield call(configRequest)
    yield put(getMeterDetailSuccessAction(response?.data))
  } catch (error) {
    const status = error?.response?.data?.status
    const msg = error?.response?.data?.error?.message
    const code = error?.response?.data?.error?.code
    yield put(
      getMeterDetailSuccessAction({
        status: status,
        code: code,
        message: msg,
      }),
    )
  }
}

function* getMonthBillDetail(action) {
  try {
    const configRequest = () => {
      return instance.get(`${Endpoint.INVOICE_GET_BILL_MONTH_YEAR}?${action.payload}`)
    }
    const response = yield call(configRequest)
    const newResult = {
      ...response?.data,
      param: queryString?.parse(action?.payload),
    }
    yield put(getMonthBillDetailSuccessAction(newResult))
  } catch (error) {
    const status = error?.response?.data?.status
    const msg = error?.response?.data?.error?.message
    const code = error?.response?.data?.error?.code
    yield put(
      getMonthBillDetailSuccessAction({
        status: status,
        code: code,
        message: msg,
        param: queryString?.parse(action?.payload),
      }),
    )
  }
}

function* getPdfBill(action) {
  try {
    const configRequest = () => {
      return instance.post(Endpoint.PDF_GET_BILL, action.payload)
    }
    const response = yield call(configRequest)
    const fileBase64 = response.data.file
    const blob = new Blob([Uint8Array.from(atob(fileBase64), (c) => c.charCodeAt(0))], {
      type: 'application/pdf',
    })
    const billDate = response.data.billDate
    const mcsCustomerCode = response.data.mcsCustomerCode
    yield put(getPdfBillSuccessAction({ blob, billDate, mcsCustomerCode }))
  } catch (error) {
    const status = error?.response?.data?.status
    const msg = error?.response?.data?.error?.message
    const code = error?.response?.data?.error?.code
    yield put(
      getPdfBillSuccessAction({
        status: status,
        code: code,
        message: msg,
      }),
    )
  }
}

export default function* getMonthContractSaga() {
  yield all([
    takeLatest(ACTION_GET_MONTH_CONTRACT, getMonthContract),
    takeLatest(ACTION_GET_MONTH_CONTRACT_ID_OLD, getMonthYearContract),
    takeLatest(ACTION_GET_MONTH_CONTRACT_ID_NEW, getMonthYearNewContract),
    takeLatest(ACTION_GET_MONTH_CONTRACT_DETAIL, getContractDetail),
    takeLatest(ACTION_GET_METER_DETAIL, getMeterDetail),
    takeLatest(ACTION_GET_MONTH_BILL_DETAIL, getMonthBillDetail),
    takeLatest(ACTION_GET_PDF_BILL, getPdfBill),
  ])
}
